import { render, staticRenderFns } from "./entity-attached-documents.vue?vue&type=template&id=6b4247b5"
import script from "./entity-attached-documents.vue?vue&type=script&lang=js"
export * from "./entity-attached-documents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports